import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Image,
  Modal,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import { InfoIcon } from "@chakra-ui/icons";
import React, { useState } from "react";
import { useMyTickets } from "../../hooks/useMyTickets.ts";
import { TicketsModal } from "./ticketsModal.tsx";
import { BaseUrl } from "../../const.ts";
import { useTranslation } from "react-i18next";



const Tickets = () => {
  const { t } = useTranslation();
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const { tickets } = useMyTickets();

  const handleOpenModal = (event: any) => setSelectedEvent(event);
  const handleCloseModal = () => setSelectedEvent(null);

  const navigateToEvent = (e: React.MouseEvent, id: string) => {
    e.stopPropagation();
    window.location.href = `/${id}`;
  };

  return (
      <Container maxW="1000px" py={"150px"}>
        <Heading fontSize={{ base: "37px", md: "45px" }}>{t("my_tickets")}</Heading>
        <Tabs variant="soft-rounded" colorScheme="blue" mt={10}>
          <TabList>
            <Tab>{t("upcoming")}</Tab>
            <Tab>{t("past")}</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <VStack spacing={5}>
                {tickets?.upcomingTickets.length ? (
                    <Box width="100%">
                      {tickets.upcomingTickets.map((event: any) => (
                          <Box
                              key={event.eventView.idEvent}
                              border="1px solid #e2e2e2"
                              borderRadius="10px"
                              mb={4}
                              overflow="hidden"
                          >
                            <Flex
                                p={5}
                                justify="space-between"
                                cursor="pointer"
                                onClick={() => handleOpenModal(event)}
                                gap={4}
                            >
                              <VStack justifyContent="center" alignItems="flex-start">
                                <Heading size="md">{event.eventView.eventName}</Heading>
                                <Text>{`${event.totalTickets} Tickets`}</Text>
                              </VStack>
                              <Box>
                                <Image
                                    src={`${BaseUrl}/images/${event.eventView.coverPhoto}`}
                                    alt="event"
                                    boxSize="100px"
                                />
                              </Box>
                            </Flex>
                            <Flex p={3} justify="flex-end" bg="gray.50">
                              <Button
                                  onClick={(e) =>
                                      navigateToEvent(e, event.eventView.idEvent)
                                  }
                              >
                                {t("view_event")}
                              </Button>
                            </Flex>
                          </Box>
                      ))}
                    </Box>
                ) : (
                    <VStack
                        h="150px"
                        p="20px"
                        justifyContent="center"
                        alignItems="center"
                    >
                      <InfoIcon color="#BEE3F8" w="40px" h="40px" />
                      <Text fontSize="18px" fontWeight={500}>
                        There is no available ticket.
                      </Text>
                    </VStack>
                )}
              </VStack>
            </TabPanel>

            <TabPanel>
              <VStack spacing={5}>
                {tickets?.oldTickets.length ? (
                    <Box width="100%">
                      {tickets.oldTickets.map((event: any) => (
                          <Box
                              key={event.eventView.idEvent}
                              border="1px solid #e2e2e2"
                              borderRadius="10px"
                              mb={4}
                              overflow="hidden"
                          >
                            <Flex
                                p={5}
                                justify="space-between"
                                cursor="pointer"
                                gap={4}
                                onClick={() => handleOpenModal(event)}
                            >
                              <VStack justifyContent="center" alignItems="flex-start">
                                <Heading size="md">{event.eventView.eventName}</Heading>
                                <Text>{`${event.totalTickets} Tickets`}</Text>
                              </VStack>
                              <Box>
                                <Image
                                    src={`${BaseUrl}/images/${event.eventView.coverPhoto}`}
                                    alt="event"
                                    boxSize="100px"
                                />
                              </Box>
                            </Flex>
                            <Flex p={3} justify="flex-end" bg="gray.50">
                              <Button
                                  onClick={(e) =>
                                      navigateToEvent(e, event.eventView.idEvent)
                                  }
                              >
                                {t("view_event")}
                              </Button>
                            </Flex>
                          </Box>
                      ))}
                    </Box>
                ) : (
                    <VStack
                        h="150px"
                        p="20px"
                        justifyContent="center"
                        alignItems="center"
                    >
                      <InfoIcon color="#BEE3F8" w="40px" h="40px" />
                      <Text fontSize="18px" fontWeight={500}>
                        There is no available ticket.
                      </Text>
                    </VStack>
                )}
              </VStack>
            </TabPanel>
          </TabPanels>
        </Tabs>

        {selectedEvent && (
            <Modal isOpen={true} onClose={handleCloseModal} size="lg">
              <TicketsModal
                  eventId={selectedEvent.eventView.idEvent}
                  eventName={selectedEvent.eventView.eventName}
              />
            </Modal>
        )}
      </Container>
  );
};

export default Tickets;
